export const BUTTONS = {
    COPY: 'copy',
    MORE_NUMBERS: 'info.moreNumbers'
};
